import { useState, useEffect, useCallback, useRef } from "react";
import "../common/Util.css";
import { ReactComponent as SearchIc } from "../../assets/svg/search.svg";
import { ReactComponent as AddIc } from "../../assets/svg/add_icon.svg";
import { ReactComponent as DownArrow } from "../../assets/svg/down_arror.svg";
import { ReactComponent as EmailView } from "../../assets/svg/email_view_ic.svg";
import { ReactComponent as ListView } from "../../assets/svg/list_view_ic.svg";
import { ReactComponent as SelectGrid } from "../../assets/svg/seelct_grid_ic.svg";
import { ReactComponent as SelectList } from "../../assets/svg/select_list_ic.svg";
import { ReactComponent as DownArrowIc } from "../../assets/svg/down_arrow_ics.svg";
import { ReactComponent as ThreeDotIC } from "../../assets/svg/three-dot-ic.svg";
import { ReactComponent as RarIc } from "../../assets/svg/rar_ic.svg";
import { ReactComponent as LarIc } from "../../assets/svg/lar_ic.svg";
import { ReactComponent as EditIc } from "../../assets/svg/edit_ic.svg";
import { ReactComponent as DeleteIc } from "../../assets/svg/delete_ic.svg";
import productDefault from "../../assets/png/product_default.png";
import { Dropdown, Toast, ToastContainer } from "react-bootstrap";
import SearchableDropdown from "../common/commonDropDown";
import ReactPaginate from "react-paginate";
import LoaderModal from "../common/loader";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../common/deleteModel";
import DateRangePicker from "../common/dateRange";
import "react-datepicker/dist/react-datepicker.css";
import { Sidebar } from "../common/Sidebar";
import { Navbar } from "../common/Navbar";
import { format } from "date-fns";

import SuppliedBy from "../common/suppliers_common";
import { deleteProductApi, getProductListApi } from "./productApi";
import { useGlobal } from "../../GlobalContext";
import ProfileImageModal from "../common/common-preview";

function ProductListingPage() {
  // location
  const navigate = useNavigate();
  // Api Url
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;

  // variable initial
  const iconStyle = { width: "16px", height: "16px" };
  const [search, setSearch] = useState("");
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [selectedSortby, setSelectedSortBy] = useState({
    value: "created desc",
    label: "Created (Newest)",
  });

  const [selectedStatus, setSelectedStatus] = useState({
    value: "",
    label: "All",
  });
  const [stageListOption, setListStageOption] = useState([
    { value: "Cancelled", label: "Cancelled" },
    { value: "Confirmed", label: "Confirmed" },
  ]);
  const [gradeSelect, setGradeSelect] = useState(null);
  const [citySelect, setCitySelect] = useState(null);
  const [active, setActive] = useState("list");
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [deleteId, setDeleteId] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [groupSelect, setGroupSelect] = useState(null);
  const [originSelect, setOriginSelect] = useState(null);
  const [startDateSave, setStartDateSave] = useState(null);
  const [endDateSave, setEndDateSave] = useState(null);
  const [sortByOption, setSortByOption] = useState([
    {
      value: "created asc",
      label: "Created (Oldest)",
    },
    { value: "created desc", label: "Created (Newest)" },
    { value: "updated asc", label: "Updated Date (Oldest)" },
    { value: "updated desc", label: "Updated Date (Newest)" },
  ]);
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState("");
  const [activeDropdown, setActiveDropdown] = useState(null); // 'sort', 'status', 'origin', 'group', 'date', 'search'
  const openFile = (fileUrl = "") => {
    if (!fileUrl) return;

    const cleanUrl = fileUrl.split("?")[0].toLowerCase();

    // 🖼 Images → popup
    if (
      cleanUrl.endsWith(".png") ||
      cleanUrl.endsWith(".jpg") ||
      cleanUrl.endsWith(".jpeg") ||
      cleanUrl.endsWith(".gif") ||
      cleanUrl.endsWith(".webp")
    ) {
      setSelectedProfile(fileUrl);
      setShowProfilePopup(true);
      return;
    }

    // 📄 PDF → open directly in browser
    if (cleanUrl.endsWith(".pdf")) {
      setSelectedProfile(fileUrl);
      setShowProfilePopup(true);
      return;
    }

    // 📊 Office files → Office Viewer
    if (
      cleanUrl.endsWith(".xls") ||
      cleanUrl.endsWith(".xlsx") ||
      cleanUrl.endsWith(".doc") ||
      cleanUrl.endsWith(".docx") ||
      cleanUrl.endsWith(".ppt") ||
      cleanUrl.endsWith(".pptx")
    ) {
      const officeViewerUrl =
        "https://view.officeapps.live.com/op/view.aspx?src=" +
        encodeURIComponent(fileUrl);

      window.open(officeViewerUrl, "_blank", "noopener,noreferrer");
      return;
    }

    // ⬇ Default → download / open
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };
  const [StatusList, setStatusList] = useState([
    {
      value: "",
      label: "All",
    },
    {
      value: true,
      label: "Active",
    },
    { value: false, label: "In-Active" },
  ]);
  const [payStatusList, setPayStatusList] = useState([
    {
      value: "",
      label: "All",
    },
    {
      value: "Pending",
      label: "Pending",
    },
    { value: "Partially-Paid", label: "Partially-Paid" },
    { value: "Paid", label: "Paid" },
  ]);
  const [productList, setProductList] = useState([]);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  // handle
  const handleSelectGradle = (option) => {
    console.log("Selected option:", option);
    setGradeSelect(option);
  };

  const handleSelectCity = (option) => {
    console.log("Selected option:", option);
    setCitySelect(option);
  };
  const handleClearGradle = () => {
    setGradeSelect(null);
  };
  const handleSelectOrgin = (option) => {
    console.log("Selected option:", option);
    setOriginSelect(option);
  };

  const handleClearOrgin = () => {
    setOriginSelect(null);
  };
  const handleSelectGroup = (option) => {
    console.log("Selected option:", option);
    setGroupSelect(option);
  };

  const handleClearGroup = () => {
    setGroupSelect(null);
  };
  const handleClearCity = () => {
    setCitySelect(null);
  };
  const handlePageClick = useCallback((event) => {
    setItemOffset(event.selected);
  }, []);

  const handleDateChange = ({ start, end }) => {
    console.log("Selected Start:", start);
    console.log("Selected End:", end);

    const formattedStart = start ? format(start, "yyyy-MM-dd") : null;
    const formattedEnd = end ? format(end, "yyyy-MM-dd") : null;

    console.log("Formatted Start:", formattedStart);
    console.log("Formatted End:", formattedEnd);

    setStartDateSave(formattedStart);
    setEndDateSave(formattedEnd);
  };
  // useEffect
  const { rolePermissionList, userType } = useGlobal();
  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === menuName &&
        element["menu_permission"] === true &&
        element[permission] === true,
    ) > -1
      ? true
      : false;
  }
  useEffect(() => {
    getproductList();
  }, [
    itemsPerPage,
    itemOffset,
    search,
    selectedSortby,
    originSelect,
    selectedStatus,
    groupSelect,
    startDateSave,
    endDateSave,
  ]);

  useEffect(() => {
    if (deleteId !== null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);
  // Api
  const updateStatus = async (id, value) => {
    setIsLoading(true);
    const bodyData = {
      status: value,
    };
    try {
      // const response = await updateStatusApi(id, bodyData);
      // console.log("response....1", response);
      // if (response.success === true) {
      //   getproductList();
      //   setSnackbarMessage(response.data.message);
      //   setSnackbarStatus(response.data.success);
      //   handleSnackbarShow();
      // }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const deleteVendor = async () => {
    // setIsLoading(true);
    try {
      const response = await deleteProductApi(deleteId);
      console.log("response....", response);
      if (response.data.success === true) {
        getproductList();
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        setDeleteId(null);
        setIsOpenDelete(false);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const getproductList = async () => {
    setIsLoading(true);
    const [field, dir] = selectedSortby?.value?.split(" ") || [
      "Created",
      "desc",
    ];
    const param = {
      limit: itemsPerPage,
      skip: itemOffset * itemsPerPage,
      search: search,
      status: selectedStatus?.value ?? "",
      origion: originSelect?.value ?? "",
      group: groupSelect?.value ?? "",
      from_date: startDateSave,
      to_date: endDateSave,
      sort_field: field,
      sort_dir: dir,
    };
    try {
      const response = await getProductListApi(param);
      if (response.data.success === true) {
        setTotalCount(response.data.total_rec ?? 0);
        setPageCount(response.data.total_pgs ?? 0);
        setProductList(response.data.products ?? []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <ProfileImageModal
        show={showProfilePopup}
        onClose={() => setShowProfilePopup(false)}
        imageUrl={selectedProfile}
      />{" "}
      <LoaderModal show={isLoading} />
      <DeleteModal
        title={"product"}
        isOpen={isOpenDelete}
        onClose={() => {
          setIsOpenDelete(false); // close modal
          setDeleteId(null); // reset selected ID
        }}
        onDelete={deleteVendor}
      />
      <div className="d-flex">
        {/* Sidebar */}
        <Sidebar currentfile="Products" />

        {/* Main Content */}
        <div className="rounded-4 flex-grow-1  ">
          {" "}
          <Navbar pageTitle="Products" />
          <div className="bg-half-white p-2">
            <div className="bg-white rounded-4 p-4">
              {" "}
              {/* First Row */}
              <div className="d-flex align-items-center justify-content-between mb-3">
                {/* Left: Heading */}
                <div className="my-heading fs-24 fw-600">
                  Products - {totalCount}
                </div>

                {/* Right: Controls */}
                <div className="d-flex flex-wrap gap-3">
                  {/* Search */}
                  <div
                    className="search-wrapper d-flex align-items-center gap-2 px-3 py-2"
                    style={{
                      border: activeDropdown === "search"
                        ? "1px solid #6c5ce7"
                        : "1px solid #EBEBEB",
                      boxShadow: activeDropdown === "search"
                        ? "0 0 0 2px rgba(108, 92, 231, 0.1)"
                        : "none",
                      transition: "all 0.2s ease-in-out",
                      borderRadius: "12px",
                    }}
                  >
                    <SearchIc />
                    <input
                      type="text"
                      placeholder="Search"
                      className="border-0 outline-0 rounded-3 fs-14 fw-500 textcolor"
                      style={{ outline: "none" }}
                      value={search || ""}
                      onChange={(e) => setSearch(e.target.value)}
                      onFocus={() => setActiveDropdown("search")}
                      onBlur={() => setActiveDropdown(null)}
                    />
                  </div>

                  {/* Add New Vendor */}
                  {checkPermission("Products", "create_permission") && (
                    <div
                      className="cursor-pointer my-box d-flex align-items-center justify-content-center gap-2 px-3"
                      onClick={() => {
                        navigate("/product/create", {
                          state: {
                            from: "product_list",
                          },
                        });
                      }}
                    >
                      <AddIc />
                      <div style={{ paddingBottom: "4px" }}>New Product</div>
                    </div>
                  )}

                  {/* Import */}
                  {/* <div className="my-import d-flex align-items-center justify-content-center gap-2">
                  <ImportIc />
                  <div style={{ paddingBottom: "4px" }}>Import</div>
                </div> */}
                </div>
              </div>
              {/* Second Row */}
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex justify-content-start gap-2">
                  <div onClick={(e) => e.stopPropagation()}>
                    <Dropdown
                      show={activeDropdown === "sort"}
                      onToggle={(isOpen) =>
                        setActiveDropdown(isOpen ? "sort" : null)
                      }
                    >
                      <Dropdown.Toggle
                        variant="light"
                        id="dropdown-sort"
                        className="d-flex align-items-center justify-content-between"
                        style={{
                          borderRadius: "12px",
                          border:
                            activeDropdown === "sort"
                              ? "1px solid #6c5ce7"
                              : "1px solid #EBEBEB",
                          padding: "6px 12px",
                          //   minWidth: "186px",
                          backgroundColor: "white",
                          boxShadow:
                            activeDropdown === "sort"
                              ? "0 0 0 2px rgba(108, 92, 231, 0.1)"
                              : "none",
                        }}
                        title={selectedSortby.label}
                      >
                        {/* Left: "Sort by" label */}
                        <span className="fs-12 fw-400 textGrey">Sort by :</span>

                        {/* Right: Selected + arrow */}
                        <span className="d-flex align-items-center px-1">
                          <span className="dropdown-text">
                            {selectedSortby.label}
                          </span>

                          <span className="dropdown-toggle-arrow textPurple">
                            <DownArrow />
                          </span>
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          backgroundColor: "white",
                          borderRadius: "8px",
                          border: "1px solid #EBEBEB",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        {sortByOption.map((option) => (
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            key={option.value}
                            onClick={(e) => {
                              setSelectedSortBy(option); // Execute your selection logic
                            }}
                            active={selectedSortby === option.value}
                          >
                            {option.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div onClick={(e) => e.stopPropagation()}>
                    <Dropdown
                      show={activeDropdown === "status"}
                      onToggle={(isOpen) =>
                        setActiveDropdown(isOpen ? "status" : null)
                      }
                    >
                      <Dropdown.Toggle
                        variant="light"
                        id="dropdown-sort"
                        className="d-flex align-items-center justify-content-between"
                        style={{
                          borderRadius: "12px",
                          border:
                            activeDropdown === "status"
                              ? "1px solid #6c5ce7"
                              : "1px solid #EBEBEB",
                          padding: "6px 12px",
                          //   minWidth: "186px",
                          backgroundColor: "white",
                          boxShadow:
                            activeDropdown === "status"
                              ? "0 0 0 2px rgba(108, 92, 231, 0.1)"
                              : "none",
                        }}
                        title={selectedStatus.label}
                      >
                        {/* Left: "Sort by" label */}
                        <span className="fs-12 fw-400 textGrey">Status :</span>

                        {/* Right: Selected + arrow */}
                        <span className="d-flex align-items-center px-1">
                          <span className="dropdown-text">
                            {selectedStatus.label}
                          </span>

                          <span className="dropdown-toggle-arrow textPurple">
                            <DownArrow />
                          </span>
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          backgroundColor: "white",
                          borderRadius: "8px",
                          border: "1px solid #EBEBEB",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        {StatusList.map((option) => (
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            key={option.value}
                            onClick={(e) => {
                              // e.stopPropagation(); // Prevent parent onClick from firing
                              setSelectedStatus(option); // Execute your selection logic
                            }}
                            active={selectedStatus.value === option.value}
                          >
                            {option.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div>
                    <SearchableDropdown
                      apiUrl={`${adminUrl}get_country`}
                      placeholder="Origin"
                      value={originSelect}
                      onSelect={handleSelectOrgin}
                      handleClear={handleClearOrgin}
                      isOpen={activeDropdown === "origin"}
                      onToggle={(isOpen) =>
                        setActiveDropdown(isOpen ? "origin" : null)
                      }
                    />
                  </div>
                  <div>
                    <SearchableDropdown
                      apiUrl={`${apiUrl}get_product_group`}
                      placeholder="Group"
                      value={groupSelect}
                      onSelect={handleSelectGroup}
                      handleClear={handleClearGroup}
                      isOpen={activeDropdown === "group"}
                      onToggle={(isOpen) =>
                        setActiveDropdown(isOpen ? "group" : null)
                      }
                    />
                  </div>
                  <div
                    className="d-flex align-items-center px-1"
                    style={{
                      borderRadius: "12px",
                      border:
                        activeDropdown === "date"
                          ? "1px solid #6c5ce7"
                          : "1px solid #EBEBEB",
                      backgroundColor: "white",
                      transition: "all 0.2s ease-in-out",
                      boxShadow:
                        activeDropdown === "date"
                          ? "0 0 0 2px rgba(108, 92, 231, 0.1)"
                          : "none",
                    }}
                    onFocusCapture={() => setActiveDropdown("date")}
                    onBlurCapture={() => setActiveDropdown(null)}
                  >
                    <span className="fs-12 fw-400 textGrey">Date :</span>
                    <span
                      className="dropdown-text1 textPurple mb-2"
                      style={{ height: "28px" }}
                    >
                      {" "}
                      <DateRangePicker onChange={handleDateChange} />
                    </span>
                  </div>{" "}
                </div>
                <div
                  className="rounded-4 toggleBg d-flex mt-2"
                  style={{
                    width: "80px",
                    height: "32px",
                    backgroundColor: "#f1f3f6", // toggle background
                    padding: "4px",
                    gap: "4px",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    onClick={() => setActive("list")}
                    className={`d-flex align-items-center justify-content-center rounded-3  ${
                      active === "list" ? "bg-primary1" : ""
                    }`}
                    style={{
                      width: "36px",
                      height: "24px",
                      cursor: "pointer",
                    }}
                  >
                    {active === "list" ? (
                      <ListView style={iconStyle} />
                    ) : (
                      <SelectList style={iconStyle} />
                    )}
                  </div>

                  <div
                    onClick={() => setActive("grid")}
                    className={`d-flex align-items-center justify-content-center rounded-3 ${
                      active === "grid" ? "bg-primary1" : ""
                    }`}
                    style={{
                      width: "36px",
                      height: "24px",
                      cursor: "pointer",
                    }}
                  >
                    {active === "grid" ? (
                      <SelectGrid style={iconStyle} />
                    ) : (
                      <EmailView style={iconStyle} />
                    )}
                  </div>
                </div>
              </div>
            </div>
            {active === "list" && (
              <div className="bg-white rounded-4 mt-3 w-100 p-3">
                <div
                  style={{
                    display: "flex",
                    flex: "10",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    paddingTop: "16px",
                    height: "40px",
                    backgroundColor: "#F2F2F2",
                  }}
                  className="head3 w-100 justify-content-center align-items-center"
                >
                  <p
                    style={{ width: "127px", flex: "1.5" }}
                    className="fs-13 fw-700 textcolor"
                  >
                    Part code
                  </p>
                  <p
                    style={{ width: "160px", flex: "1.5" }}
                    className="fs-13 fw-700 textcolor"
                  >
                    Name
                  </p>
                  <p
                    style={{ width: "160px", flex: "1" }}
                    className="fs-13 fw-700 textcolor"
                  >
                    UOM
                  </p>{" "}
                  <p
                    style={{ width: "160px", flex: "2.5" }}
                    className="fs-13 fw-700 textcolor"
                  >
                    Supplier
                  </p>{" "}
                  <p
                    style={{ width: "160px", flex: "1" }}
                    className="fs-13 fw-700 textcolor"
                  >
                    Status
                  </p>{" "}
                </div>
                <div>
                  {(productList ?? []).map((item, index) => (
                    <div
                      style={{
                        display: "flex",
                        flex: "10",
                        paddingLeft: "16px",
                        paddingRight: "16px",

                        backgroundColor:
                          hoveredIndex === index ? "#FAFAFA" : "#FFFFFF",
                        borderBottom: "1px solid #D4DDE7",
                        cursor: "pointer",
                        height: "44px",
                      }}
                      onClick={() => {
                        navigate("/product/view", {
                          state: { id: item.id },
                        });
                      }}
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                      className="head3 w-100 justify-content-center align-items-center"
                    >
                      {" "}
                      {/* <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={handleChange}
                        style={{ marginRight: "8px", marginBottom: "0px" }}
                      /> */}
                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "1.5",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.code}
                      >
                        {item.code ?? "---"}
                      </p>
                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "1.5",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.name}
                      >
                        <img
                          key={index}
                          src={
                            item.image && item.image.trim() !== ""
                              ? item.image
                              : productDefault
                          }
                          onClick={(e) => {
                            e.stopPropagation();
                            openFile(item.image ? item.image : productDefault);
                          }}
                          alt="Profile"
                          className="avatar-item me-1 ms-0"
                        />
                        {item.name ?? "---"}
                      </p>
                      <div
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "1",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                        }}
                        title={item.uom}
                      >
                        {item.uom ?? "---"}
                      </div>
                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "2.5",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.payment_status}
                      >
                        <SuppliedBy suppliers={item.suppliers ?? []} />
                      </p>
                      <p
                        className="fs-13 fw-500 textcolor d-flex gap-2"
                        style={{
                          flex: "1",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.status === true ? "Active" : "In-Active"}
                      >
                        <div
                          style={{
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%", // optional, for a circle
                            marginTop: "6px",
                            backgroundColor:
                              item.status === true ? "#4EBD7E" : "#FF4444",
                          }}
                        ></div>
                        {item.status === true ? "Active" : "In-Active"}
                      </p>
                      {hoveredIndex === index && (
                        <div
                          style={{
                            position: "absolute",
                            // top: "50%",
                            right: "35px",
                            // transform: "translate(-50%, -50%)",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "start",
                              alignItems: "center",
                            }}
                          >
                            {checkPermission("Products", "edit_permission") && (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate("/product/create", {
                                    state: {
                                      id: item.id,
                                      from: "product_list",
                                    },
                                  });
                                }}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "28px",
                                  height: "28px",
                                  borderRadius: "100px",
                                  background: "#FFFFFF",
                                  cursor: "pointer",
                                  border: "0.8px solid #E5E5E5",
                                }}
                              >
                                <EditIc />{" "}
                              </div>
                            )}
                            <span style={{ marginLeft: "16px" }}></span>
                            {checkPermission(
                              "Products",
                              "delete_permission",
                            ) && (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setDeleteId(item.id);
                                }}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "28px",
                                  height: "28px",
                                  borderRadius: "100px",
                                  background: "#FFFFFF",
                                  cursor: "pointer",
                                  border: "0.8px solid #E5E5E5",
                                }}
                              >
                                <DeleteIc />{" "}
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
            {active === "grid" &&
              productList.map((product, index) => (
                <div
                  key={index}
                  className="d-flex align-items-center justify-content-between   business-card w-100 p-3 mt-3"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (checkPermission("Products", "view_permission")) {
                      navigate("/product/view", {
                        state: { id: product.id },
                      });
                    }
                  }}
                >
                  <div className="d-flex flex-grow-1  w-25">
                    <div className="profile-wrapper backgroundLitgrey">
                      <img
                        src={
                          product.image && product.image.trim() !== ""
                            ? product.image
                            : productDefault
                        }
                        alt="Profile"
                        className="profile-img"
                      />
                    </div>
                    <div className="d-flex flex-column gap-2 ps-3">
                      <div className="textcolor fs-16 fw-400 ">
                        {product.name ?? "-"}
                      </div>

                      <div className="d-flex gap-2  align-items-center">
                        <div className="d-flex flex-row gap-2">
                          <div className="fs-12_5 fw-400 textGrey">Code :</div>
                          <div className="fs-12_5 fw-500 cardTextBlue">
                            {product.code ?? "-"}
                          </div>
                        </div>
                        <span
                          style={{
                            width: "4px",
                            height: "4px",
                            backgroundColor: "#D9D9D9",
                            borderRadius: "50%",

                            display: "inline-block",
                          }}
                        ></span>
                        <div className="rounded-4 backgroundBlue px-2 py-1 textBlue fs-11 fw-500">
                          {product.uom ?? "-"}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex flex-column gap-2 ps-3 flex-grow-1  w-25">
                    <SuppliedBy suppliers={product.suppliers ?? []} />
                  </div>
                  {
                    <div className="d-flex flex-row flex-grow-1 align-items-end justify-content-end gap-2 ps-3  w-25">
                      <div className="d-flex flex-row flex-grow-1 align-items-end justify-content-end gap-2 ps-3  w-25">
                        <div onClick={(e) => e.stopPropagation()}>
                          {product.po_status === "Draft" ? (
                            <Dropdown>
                              <Dropdown.Toggle
                                variant="light"
                                id="dropdown-sort"
                                className="d-flex align-items-center justify-content-between backgroundGreenLt rounded-5"
                                style={{
                                  padding: "6px 12px",
                                }}
                              >
                                <span className="d-flex align-items-center px-1 gap-2">
                                  <span
                                    className="backgroundGreen"
                                    style={{
                                      width: "10px",
                                      height: "10px",
                                      borderRadius: "3px",
                                      display: "inline-block",
                                    }}
                                  ></span>

                                  <span className="dropdown-text textcolor fs-13 fw-500">
                                    {product.status === true
                                      ? "Active"
                                      : "In-Active"}
                                  </span>

                                  <span className="dropdown-toggle-arrow">
                                    <DownArrowIc />
                                  </span>
                                </span>
                              </Dropdown.Toggle>

                              <Dropdown.Menu
                                style={{
                                  backgroundColor: "white",
                                  borderRadius: "8px",
                                  border: "1px solid #EBEBEB",
                                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                }}
                              >
                                {stageListOption.map((option) => (
                                  <Dropdown.Item
                                    className="fs-14 fw-500 textcolor"
                                    key={option}
                                    onClick={() =>
                                      updateStatus(product.id, option.value)
                                    }
                                    // active={selected === option}
                                  >
                                    {option.label}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                          ) : (
                            <div
                              style={{
                                padding: "6px 12px",
                                height: "36px",
                              }}
                              className="d-flex align-items-center justify-content-between backgroundGreenLt rounded-5"
                            >
                              <span className="d-flex align-items-center px-1 gap-2">
                                <span
                                  className="backgroundGreen"
                                  style={{
                                    width: "10px",
                                    height: "10px",
                                    borderRadius: "3px",
                                    display: "inline-block",
                                  }}
                                ></span>

                                <span className="dropdown-text textcolor fs-13 fw-500">
                                  {product.status === true
                                    ? "Active"
                                    : "In-Active"}
                                </span>
                              </span>
                            </div>
                          )}
                        </div>
                      </div>

                      <div onClick={(e) => e.stopPropagation()}>
                        {(checkPermission("Products", "edit_permission") ||
                          checkPermission("Products", "delete_permission")) && (
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="light"
                              id="dropdown-sort"
                              className="d-flex align-items-center justify-content-between rounded-5 bg-white"
                              style={{
                                width: "36px",
                                height: "36px",
                                border: "1px solid #EBEBEB",
                              }}
                            >
                              <span className="d-flex align-items-center px-1 gap-2">
                                <ThreeDotIC />
                              </span>
                            </Dropdown.Toggle>

                            <Dropdown.Menu
                              style={{
                                backgroundColor: "white",
                                borderRadius: "8px",
                                border: "1px solid #EBEBEB",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                              }}
                            >
                              {checkPermission(
                                "Products",
                                "edit_permission",
                              ) && (
                                <Dropdown.Item
                                  className="fs-14 fw-500 textcolor"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    navigate("/product/create", {
                                      state: {
                                        id: product.id,
                                        from: "product_list",
                                      },
                                    });
                                  }}
                                >
                                  Edit
                                </Dropdown.Item>
                              )}

                              {checkPermission(
                                "Products",
                                "delete_permission",
                              ) && (
                                <Dropdown.Item
                                  className="fs-14 fw-500 textcolor"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setDeleteId(product.id);
                                  }}
                                >
                                  Delete
                                </Dropdown.Item>
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                        )}
                      </div>

                      {/* {product.po_status !== "Draft" && (
                        <div style={{ width: "36px", height: "36px" }}></div>
                      )} */}
                    </div>
                  }
                </div>
              ))}
            <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
              <Dropdown>
                <span className="pagination-color">
                  Records per page: &nbsp;
                </span>
                <Dropdown.Toggle
                  id="dropdown-basic"
                  className="bg-transparent pagination-color  border-0 custom-dropdown-toggle p-0"
                >
                  <span className="bg-white textcolor no-of-rows rounded-3 px-2 py-2">
                    {itemsPerPage} <DownArrowIc />
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  className="my-2"
                  style={{ minWidth: "unset", width: "30%" }}
                >
                  {[10, 25, 50, 75, 100].map((size) => (
                    <Dropdown.Item
                      key={size}
                      onClick={() => {
                        setItemsPerPage(size);
                      }}
                      active={itemsPerPage === size}
                      className="text-center"
                    >
                      {size}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <div className="d-flex align-items-center gap-2">
                <ReactPaginate
                  previousLabel={
                    <div
                      className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                      style={{
                        width: "32px",
                        height: "32px",
                      }}
                    >
                      <LarIc />
                    </div>
                  }
                  nextLabel={
                    <div
                      className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                      style={{
                        width: "32px",
                        height: "32px",
                      }}
                    >
                      <RarIc />
                    </div>
                  }
                  breakLabel={"..."}
                  pageCount={pageCount + 1}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
}

export default ProductListingPage;
